module.exports = __webpack_public_path__ + "static/bg1-00bd5b7eed95b67b2bdd07a2c0ac7ff5.png";